import { Col, Row, Tooltip } from "antd";
import React from "react";
import { Creation } from "../../utils-creation/types";
import "./Creation.css";

function TitleInEnglish({ title }: { title: string | undefined }) {
  if (!title) return null;

  return (
    <span>
      <em>({title})</em>
    </span>
  );
}

interface Props {
  creation: Creation;
}

export default function CreationTitle({ creation }: Props) {
  const title = (
    <>
      {/* Title */}
      {creation.url && (
        <p>
          <Tooltip
            overlayClassName="sub-heading-font"
            title="Research Creation Page"
            placement="topLeft"
          >
            <a href={creation.url} target="_blank" rel="noopener noreferrer">
              <em>
                <u>{creation.title}</u>
              </em>
            </a>
          </Tooltip>{" "}
          <TitleInEnglish title={creation.title_in_english} />
        </p>
      )}

      {!creation.url && (
        <p>
          <em>
            <u>{creation.title}</u>
          </em>{" "}
          <TitleInEnglish title={creation.title_in_english} />
        </p>
      )}
    </>
  );

  return (
    <Row>
      <Col className="creation-title">{title}</Col>
    </Row>
  );
}
